import { CheckCircle, RadioButtonUnchecked, Redeem } from "@mui/icons-material";
import { Step, StepLabel, Stepper } from "@mui/material";
import useCart from "../utils/useCart";
import { isDoubleDpc } from "../utils/config";


export default function Timeline(){

    const { cart } = useCart()

    if (!isDoubleDpc) return <></>;

    return window.innerWidth > 1000 &&

        <Stepper activeStep={cart.dpcStep} sx={{mb: 2}}>

            <Step>
                <StepLabel StepIconComponent={CustomStepIcon}>
                    1ère formation
                </StepLabel>
            </Step>

            <Step>
                <StepLabel StepIconComponent={CustomStepIcon}>
                    2ème formation
                </StepLabel>
            </Step>


            <Step>
                <StepLabel StepIconComponent={RedeemIcon}>
                    Obtenez votre récompense
                </StepLabel>
            </Step>


        </Stepper>

}

function CustomStepIcon({ active, completed }){
  
    return completed ?
        <CheckCircle color="info" /> :
        <RadioButtonUnchecked color={active ? 'info' : 'action'} />
        
};

function RedeemIcon({ completed }){

    return <Redeem color={completed ? 'info' : 'action'} />
}